import { CREATE_SPONSORS_LOADING, CREATE_SPONSORS_SUCCESS, CREATE_SPONSORS_ERROR } from "../../../constant/actionTypes";

const createSponsorReducer = (state = {}, action) => {
    switch (action.type) {
        case CREATE_SPONSORS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case CREATE_SPONSORS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case CREATE_SPONSORS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default createSponsorReducer;